import React from 'react'
import { FiUser, FiRefreshCw } from 'react-icons/fi'

import { button } from './LogInOutButton.module.scss'

export const LogInButton = ({ 
  microcopy, 
  handleLogin, 
  waiting 
}) => {
  return (
    <a className={button} 
      onClick={handleLogin} 
      data-redirecting={waiting}
    >
      { waiting ?  <FiRefreshCw/> :  <FiUser/> }
      { microcopy.text('explorer.buttons.login') }
    </a>
  )
}

export default LogInButton
